import React from "react";
import { observer } from "mobx-react";
import { ProvinceStateUpdateStore } from "../../store";
import { ProvinceStateUpdateForm } from "./ProvinceStateUpdateForm";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";
import { OutdatedAfterSaveNotice } from "../../../../common/controls/forms/OutdatedAfterSaveNotice";

export type ProvinceStateUpdateProps = {
  provinceStateUpdateStore: ProvinceStateUpdateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const ProvinceStateUpdate: React.FC<ProvinceStateUpdateProps> = observer(
  ({ provinceStateUpdateStore, showToolbox = true, showSaveFooter }) => {
    return (
      <>
        <SavingOverlay open={provinceStateUpdateStore.isSaving} />
        <OutdatedAfterSaveNotice
          open={provinceStateUpdateStore.savedButOutdated}
          onReload={() => provinceStateUpdateStore.reloadProvinceState()}
          reloadDisabled={provinceStateUpdateStore.isProcessing}
        />
        <ProvinceStateUpdateForm
          provinceStateUpdateStore={provinceStateUpdateStore}
          name_esError={provinceStateUpdateStore.errors.name_es?.message}
          onName_esChange={(value: string) => {
            provinceStateUpdateStore.setName_esValue(value);
          }}
          name_es={provinceStateUpdateStore.entityValues.name_es}
          name_enError={provinceStateUpdateStore.errors.name_en?.message}
          onName_enChange={(value: string) => {
            provinceStateUpdateStore.setName_enValue(value);
          }}
          name_en={provinceStateUpdateStore.entityValues.name_en}
          name_ptError={provinceStateUpdateStore.errors.name_pt?.message}
          onName_ptChange={(value: string) => {
            provinceStateUpdateStore.setName_ptValue(value);
          }}
          name_pt={provinceStateUpdateStore.entityValues.name_pt}
          countryError={provinceStateUpdateStore.errors.country?.message}
          onCountryChange={(value) => {
            provinceStateUpdateStore.setCountryValue(value);
          }}
          countrySelectedValue={
            provinceStateUpdateStore.entityValues.showCountry
          }
          onCountrySelected={(value) => {
            provinceStateUpdateStore.setSelectedCountry(value);
          }}
          countryOptions={provinceStateUpdateStore.getCountryOptions()}
          showToolbox={showToolbox}
          showSaveFooter={showSaveFooter}
          saving={provinceStateUpdateStore.saveDisabled}
          onSave={() => provinceStateUpdateStore.saveProvinceState()}
          onCancel={() => provinceStateUpdateStore.cancelProvinceState()}
        />
        <ErrorDialog
          open={provinceStateUpdateStore.errorDialogOpened}
          title={provinceStateUpdateStore.errorTitle}
          description={provinceStateUpdateStore.errorDescription}
          onClose={() => provinceStateUpdateStore.closeErrorDialog()}
        />
        <ConfirmCancelDialog
          open={provinceStateUpdateStore.confirmDialogOpened}
          title={provinceStateUpdateStore.confirmDialogTitle}
          description={provinceStateUpdateStore.confirmDialogDescription}
          onConfirm={() => provinceStateUpdateStore.executeConfirmedAction()}
          onCancel={() => provinceStateUpdateStore.closeConfirmDialog()}
        />
      </>
    );
  }
);
